import { render } from "./MenuImageScroll.vue?vue&type=template&id=20b9e589&scoped=true"
import script from "./MenuImageScroll.vue?vue&type=script&lang=js"
export * from "./MenuImageScroll.vue?vue&type=script&lang=js"

import "./MenuImageScroll.vue?vue&type=style&index=0&id=20b9e589&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b9e589"]])

export default __exports__